export const LOADING_MESSAGES = [
  'Loading...',
  'One moment please...',
  'Thanks for your patience...',
];
